<template>
  <div class="carousel">
    <div class="gundongBox" v-if="row1Images.length > 0">
      <div class="gundong">
        <div class="topgun">
          <div class="scroll-container" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
            <div class="smallbox" v-for="(item, index) in row1Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 -->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" :alt="imgUrl?.url.replace(/\/$/, '')+item.cover"/>
              <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" :alt="'http://127.0.0.1'+item.cover"/> -->
              <div class="name">{{item.title}}</div>
            </div>
            <div class="smallbox" v-for="(item, index) in row1Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 -->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" />
              <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" /> -->
              <div class="name">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row-2" v-if="row2Images.length > 0">
      <div class="gundong">
        <div class="topgun">
          <div class="scroll-container" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
            <div class="smallbox" v-for="(item, index) in row2Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 -->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" />
              <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" /> -->
              <div class="name">{{item.title}}</div>
            </div>
            <div class="smallbox" v-for="(item, index) in row2Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 -->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" />
              <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" /> -->
              <div class="name">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row-3" v-if="row3Images.length > 0">
      <div class="gundong">
        <div class="topgun">
          <div class="scroll-container" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
            <div class="smallbox" v-for="(item, index) in row3Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 -->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" :alt="imgUrl?.url.replace(/\/$/, '')+item.cover"/>
              <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" :alt="'http://127.0.0.1'+item.cover"/> -->
              <div class="name">{{item.title}}</div>
            </div>
            <div class="smallbox" v-for="(item, index) in row3Images" :key="index" @click="handleClick(item)">
              <!-- 测试 -->
              <!-- <img src="https://picsum.photos/id/1020/600/800" class="slide-image" /> -->
              <!-- 正式 imgUrl?.url.replace(/\/$/, '')-->
              <img :src="imgUrl?.url.replace(/\/$/, '')+item.cover" class="slide-image" />
               <!-- <img :src="'http://127.0.0.1'+item.cover" class="slide-image" /> -->
              <div class="name">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 全部无数据时显示提示 -->
    <div class="no-data-tip" v-if="!row1Images.length && !row2Images.length && !row3Images.length">
      暂无相关内容
    </div>


  </div>
</template>



<script>
  export default {
    name: 'ThreeRowCarousel',
    props: {
      imgUrl: {
        type: Object,
        default: {}, // 默认空数组
      },
      images: {
        type: Array,
        required: true,
        default: () => [],
        validator: value => {
          return value.every(item => {
            return 'cover' in item && 'title' in item && 'intro' in item
          })
        }
      }
    },

    data() {
      return {
        // images: [{
        //     url: 'https://randomuser.me/api/portraits/men/5.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        //   {
        //     url: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     name:'会员名称'
        //   },
        // ],
        isScrolling: true, // 用于控制是否滚动
      };
    },
    computed: {
      // 根据intro字段分类
      row1Images() {
        return this.images.filter(item => item.intro.includes('【1】'))
      },
      row2Images() {
        return this.images.filter(item => item.intro.includes('【2】'))
      },
      row3Images() {
        // 包含【3】或没有正确标记的都放在第三行
        return this.images.filter(item =>
            item.intro.includes('【3】') ||
            (!item.intro.includes('【1】') && !item.intro.includes('【2】'))
          )
      }
    },
    methods: {
      pauseScroll(event) {
        // 当鼠标进入时，停止动画
        event.target.style.animationPlayState = 'paused';
      },
      resumeScroll(event) {
        // 当鼠标离开时，恢复动画
        event.target.style.animationPlayState = 'running';
      },
      handleClick(item) {
        console.log("会员风采item", item)
        // 触发点击事件，父组件可以监听 @item-click 来处理
        // 使用 localePath 处理多语言路由
        const path = this.localePath(`/submenu/hyfc/subarticle/${item.id}`)

        // 方式1：普通跳转
        this.$router.push(path)
        // this.$emit('item-click', item);
      }
    }
  };
</script>



<style lang="scss" scoped>
  .carousel {
    padding: 0 0 1vw 0;
  }

  // 无数据提示样式
  .no-data-tip {
    text-align: center;
    padding: 2vw 0;
    color: #999;
    font-size: 1.2vw;
  }

  .gundong {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;

    .topgun {
      height: auto;
      display: flex;
      overflow: hidden;
      position: relative;

      .name {
        position: absolute;
        bottom: 0;
        z-index: 999;
        background-color: rgba(255, 255, 255, 0.4);
        padding: 0.2vw;
        // margin-top: 0.5vw;
        width: 100%;
        max-width: 20vw;
        font-size: 1vw;
        color: #000;
        overflow: hidden;
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */
        white-space: nowrap;
        /* 不允许换行 */
      }

      // .scroll-container {
      //   display: flex;
      //   animation: slide 20s linear infinite;
      // animation-play-state: running; /* 默认状态为运行 */

      .smallbox {
        // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        // border-radius: 0.5vw;
        width: 20vw;
        background-color: #fff;

        margin: 0.1vw;
        // padding: 0 0.1vw;


        img.slide-image {
          // border-radius: 0.5vw;
          width: 100%;
          height: 10vw;
          object-fit: contain;
          display: flex;
        }
      }

      .smallbox:hover {
        // border-radius: 0.5vw;
        transform: scale(1.03);
        /* 鼠标悬停时放大 */
      }

      // }
    }

    .scroll-container:hover {
      cursor: pointer;
      animation-play-state: 'paused';
    }
  }

  .row-2 {
    margin-top: 0.1vw;

    .scroll-container {
      display: flex;
      animation: moves 30s linear infinite;
    }

    @keyframes slide {
      0% {
        transform: translateX(0%);
      }

      100% {
        transform: translateX(-50%); // 滚动一个小框的宽度
      }
    }

    @keyframes moves {
      0% {
        transform: translateX(-50%);
      }

      100% {
        transform: translateX(0%); // 滚动一个小框的宽度
      }
    }
  }

  .row-3,
  .gundongBox {
    margin-top: 0.1vw;

    .scroll-container {
      display: flex;
      animation: slide 30s linear infinite;
    }

    @keyframes slide {
      0% {
        transform: translateX(0%);
      }

      100% {
        transform: translateX(-50%); // 滚动一个小框的宽度
      }
    }

    @keyframes moves {
      0% {
        transform: translateX(-50%);
      }

      100% {
        transform: translateX(0%); // 滚动一个小框的宽度
      }
    }
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .no-data-tip {
      font-size: 3vw;
      padding: 4vw 0;
    }

    .gundong {
      width: 100%;

      .topgun {
        .name {
          font-size: 2vw;
          min-width: 150px;
        }

        .smallbox {
          min-width: 150px;
          margin: 0.1vw;
          // margin: 3px;
          // padding: 3px;

          img.slide-image {
            height: 90px;
          }
        }
      }

      .scroll-container {
        animation-duration: 30s;
      }
    }

    .row-2 .scroll-container,
    .row-3 .scroll-container,
    .gundongBox .scroll-container {
      animation-duration: 30s;
    }
  }

  /* 小屏幕手机适配 */
  @media (max-width: 480px) {
    .no-data-tip {
      font-size: 4vw;
      padding: 5vw 0;
    }

    .gundong {
      .topgun {
        .name {
          min-width: 100px;
        }

        .smallbox {
          margin: 0.1vw;
          min-width: 100px;

          img.slide-image {
            height: 60px;
          }
        }
      }

      .scroll-container {
        animation-duration: 30s;
      }
    }

    .row-2 .scroll-container,
    .row-3 .scroll-container,
    .gundongBox .scroll-container {
      animation-duration: 30s;
    }
  }
</style>
